import React, { useState, useEffect, useCallback } from 'react';
import { Container, Card, Form, Button, Spinner, Alert, Table, Row, Col, Modal, Pagination, Image } from 'react-bootstrap';
import axios from 'axios';
import { useEntidadeContext } from '../EntidadeContext';
import logoImage from '../img/logo.png';

const AuditoriaPage = () => {
    const { currentEntidade } = useEntidadeContext();
    const [logs, setLogs] = useState([]);
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [pagination, setPagination] = useState({});
    
    const [filters, setFilters] = useState({
        data_inicio: '',
        data_fim: '',
        user_id: '',
        acao: '',
    });

    const [showDetailModal, setShowDetailModal] = useState(false);
    const [selectedLog, setSelectedLog] = useState(null);

    const fetchLogs = useCallback(async (page = 1) => {
        if (!currentEntidade?.id) return;

        setIsLoading(true);
        setError(null);
        try {
            const params = {
                page,
                entidade_id: currentEntidade.id,
                ...filters
            };
            const response = await axios.get('/api/auditoria', { params });
            setLogs(response.data.logs.data || []);
            setUsers(response.data.users || []);
            setPagination({
                currentPage: response.data.logs.current_page,
                totalPages: response.data.logs.last_page,
            });
        } catch (err) {
            setError(err.response?.data?.message || 'Não foi possível carregar os logs de auditoria.');
            console.error("Erro ao buscar logs:", err);
        } finally {
            setIsLoading(false);
        }
    }, [currentEntidade, filters]);

    useEffect(() => {
        fetchLogs(1); // Busca na primeira página ao carregar ou ao mudar filtros
    }, [fetchLogs]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleSearch = () => {
        fetchLogs(1); // Reinicia a busca na primeira página
    };

    const openDetailModal = (log) => {
        setSelectedLog(log);
        setShowDetailModal(true);
    };

    const closeDetailModal = () => {
        setShowDetailModal(false);
        setSelectedLog(null);
    };

    const renderPaginationItems = () => {
        if (!pagination.totalPages || pagination.totalPages <= 1) return null;
        let items = [];
        for (let number = 1; number <= pagination.totalPages; number++) {
            items.push(
                <Pagination.Item key={number} active={number === pagination.currentPage} onClick={() => fetchLogs(number)}>
                    {number}
                </Pagination.Item>
            );
        }
        return <Pagination className="justify-content-center">{items}</Pagination>;
    };

    return (
        <>
            <div style={{ border: '1px solid gray', backgroundColor: '#f5f5f5' }}>
                <div className="header" style={{ minHeight: '80px' }}>
                    <Row className="p-1 align-items-center" style={{ minHeight: 'inherit' }}>
                        <Col xs={12} md={6} style={{ minHeight: '60px' }}>
                            <div className="d-flex align-items-center justify-content-start h-100">
                                <Image src={logoImage} alt="Logo Clínica" style={{ maxHeight: '60px', marginLeft: '12px' }} />
                                <h3 style={{ marginLeft: '15px', marginBottom: '0' }}>Logs de Auditoria</h3>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="body p-3">
                    <Card className="mb-4">
                        <Card.Header>Filtros</Card.Header>
                        <Card.Body>
                            <Form>
                                <Row className="align-items-end">
                                    <Col md={3}><Form.Group><Form.Label>Data Início</Form.Label><Form.Control type="date" name="data_inicio" value={filters.data_inicio} onChange={handleFilterChange} /></Form.Group></Col>
                                    <Col md={3}><Form.Group><Form.Label>Data Fim</Form.Label><Form.Control type="date" name="data_fim" value={filters.data_fim} onChange={handleFilterChange} /></Form.Group></Col>
                                    <Col md={2}>
                                        <Form.Group>
                                            <Form.Label>Usuário</Form.Label>
                                            <Form.Select name="user_id" value={filters.user_id} onChange={handleFilterChange}>
                                                <option value="">Todos</option>
                                                {users.map(user => <option key={user.id} value={user.id}>{user.name}</option>)}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={2}><Form.Group><Form.Label>Ação</Form.Label><Form.Control type="text" name="acao" value={filters.acao} onChange={handleFilterChange} placeholder="Ex: ..._COMISSAO" /></Form.Group></Col>
                                    <Col md={2} className="d-grid"><Button variant="primary" onClick={handleSearch} disabled={isLoading}>Buscar</Button></Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>

                    {isLoading ? (
                        <div className="text-center"><Spinner animation="border" /></div>
                    ) : error ? (
                        <Alert variant="danger">{error}</Alert>
                    ) : (
                        <Table striped bordered hover responsive size="sm">
                            <thead>
                                <tr>
                                    <th>Data/Hora</th>
                                    <th>Responsável pela alteração</th>
                                    <th>Ação</th>
                                    <th>Funcionalidade</th>
                                    <th>Registro Afetado</th>
                                    <th>Detalhes</th>
                                </tr>
                            </thead>
                            <tbody>
                                {logs.length > 0 ? logs.map(log => (
                                    <tr key={log.id}>
                                        <td>{new Date(log.created_at).toLocaleString('pt-BR')}</td>
                                        <td>{log.user?.nome || 'Usuário Removido'}</td>
                                        <td>{log.acao}</td>
                                        <td>{log.funcionalidade}</td>
                                        <td>{log.tabela_afetada} (ID: {log.registro_id})</td>
                                        <td className="text-center">
                                            <Button variant="outline-info" size="sm" onClick={() => openDetailModal(log)}>Ver</Button>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr><td colSpan="6" className="text-center">Nenhum log encontrado.</td></tr>
                                )}
                            </tbody>
                        </Table>
                    )}
                    {renderPaginationItems()}
                </div>
            </div>

            {/* Modal de Detalhes */}
            <Modal show={showDetailModal} onHide={closeDetailModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Detalhes da Alteração</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedLog && (
                        <Row>
                            <Col md={6}>
                                <h5>Antes</h5>
                                <pre className="bg-light p-2 rounded"><code>{JSON.stringify(selectedLog.conteudo_anterior, null, 2)}</code></pre>
                            </Col>
                            <Col md={6}>
                                <h5>Depois</h5>
                                <pre className="bg-light p-2 rounded"><code>{JSON.stringify(selectedLog.conteudo_novo, null, 2)}</code></pre>
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeDetailModal}>Fechar</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AuditoriaPage;
